import { postData, getData, putData } from '../axiosServices'

export const getAllPracticeNotes = async (coe_Id,lab_Id) => {
    let url = `dailynotes/coe/${coe_Id}/lab/${lab_Id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};


export const addPracticeNotes = (coeID, labID, makerPlanID, moduleID, topicID, data) => {
    const url = `dailynotes/coe/${coeID}/lab/${labID}/makerplan/${makerPlanID}/module/${moduleID}/topic/${topicID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const UpdatePracticeNotes = (noteID, coeID, labID, makerPlanID, moduleID, topicID, data) => {
    const url = `dailynotes/${noteID}/coe/${coeID}/lab/${labID}/makerplan/${makerPlanID}/module/${moduleID}/topic/${topicID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return putData(url, data, { headers });
}
export const disablePracticeNotes = (noteID, coeID, labID, makerPlanID, moduleID, topicID) => {
    const url = `dailynotes/${noteID}/coe/${coeID}/lab/${labID}/makerplan/${makerPlanID}/module/${moduleID}/topic/${topicID}/isdisable`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return putData(url, {}, { headers });
}
export const getPracticeNotesQR = (noteID ) => {
    const url = `dailynotes/${noteID}/qrcode`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url,{}, { headers,responseType: 'blob'});
}